// Absolute on purpose: /contact-sales is an apps/marketing route that only
// exists on the canonical public site. toPublicWebUrl() falls back to the
// document origin when the __PPLX_PUBLIC_WEB_ORIGIN__ override is unset —
// which it is on ask web deployments — so it 404s on preview/testing hosts
// that serve only the ask app.
export const CONTACT_SALES_URL = 'https://www.perplexity.ai/contact-sales';
export const TALK_TO_SALES_UTM_SOURCE = 'perplexity_app';
export const TALK_TO_SALES_UTM_MEDIUM = 'talk_to_sales_cta';
//# sourceMappingURL=constants.js.map